var grid = "https://shopfront-cdn.tekoapis.com/static/bdd63e78510785e1.svg";

export { grid as default };
